import { identity } from 'lodash';
import { createDeepSelector } from '../../../../../utils/milanoteReselect/milanoteReselect';
import type { CellSelections } from '../../../../../../common/table/TableTypes';
import type { ActiveTableSelector } from '../hotTableStoreHooks';
import type { ActiveTableObject } from '../hotTableStoreTypes';

/** Returns the live selection for the active HoT instance. */
export const selectActiveTableCellSelection: ActiveTableSelector<CellSelections | undefined> = createDeepSelector<
    ActiveTableObject | undefined,
    unknown,
    CellSelections | undefined
>(
    // The HoT instance reference is stable, so selection must be read in the input selector.
    (activeTableState) => activeTableState?.instance?.getSelected(),
    identity,
);

/** Returns the live selection only when the active V2 table matches the requested element. */
export const selectActiveTableCellSelectionForElement =
    (elementId: string): ActiveTableSelector<CellSelections | undefined> =>
    (activeTableState) => {
        if (!activeTableState || activeTableState.elementId !== elementId) return;
        return selectActiveTableCellSelection(activeTableState);
    };
